'use client';

import Icon from './Icon';
import svg from 'sprites/about-us.svg';

export default function IconAboutUs({
  className = 'w-7 h-7 fill-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
